import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./ModuleChange.css";




function FactoryOutCheckModal({
  show,
  hide,
  showModal,
  button,
}) {
 
 

  

  return (
    <>
      <Modal
        show={show || showModal.status}
        centered
        className="ChangeModal"
        dialogClassName="deleteWidthClass"
        contentClassName="deleteHeightClass"
      >
        <Modal.Header style={{  display: "flex",
          justifyContent: "center",
          alignItems: "center",}}>
        <div className="ChangeModal__title">Alert</div>
        </Modal.Header>
        <Modal.Body>
        <button className="moduleChange__closeBtn" onClick={hide}>
                <i class="bx bxs-x-square"></i>
              </button>
          <div className="ChangeModal__container">
           

            <div className="ChangeModal__description">
            {showModal.msg}
             {/* Factory Out Flag is True we can not change module  */}
            </div>
            <div className="ChangeModal__Btn">
              <Button
                className="ChangeModal__noBtn"
                onClick={()  => hide()} 
              >
                {button}
              </Button>
             
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default FactoryOutCheckModal;
